/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
// Behaviour for lesson panels display.
$(document).on("turbo:load", function () {
  if ($(".panels").length) {
    return new Panels()
  }
})

class Panels {
  constructor() {
    this.onPanelSubtreeMod = this.onPanelSubtreeMod.bind(this)
    this.updatePanels = this.updatePanels.bind(this)
    this.lessonsAll = new App.lessonsAll()
    this.bindElements()
    this.checkHashForPanelName()
    this.gotoQuestion()
  }

  checkHashForPanelName() {
    $(window).load(() => {
      if (window.location.hash) {
        return this.activatePanel(window.location.hash)
      }
    })

    return window.addEventListener("hashchange", () => {
      if (window.location.hash) {
        return this.activatePanel(window.location.hash)
      }
    })
  }

  activatePanel(hash) {
    switch (hash) {
      case "#discuss":
        $("a[data-panel='discussion']").click()
        if ($(".discussHeader").hasClass("guided")) {
          return $(".discussTab.guided a").click()
        } else {
          return $(".discussTab.open a").click()
        }
      case "#discussion-open":
        $("a[data-panel='discussion']").click()
        if ($(".discussHeader").hasClass("guided")) {
          return $(".discussTab.guided a").click()
        } else {
          return $(".discussTab.open a").click()
        }
      case "#watch":
        return $("a[data-panel='watch']").click()
      case "#review":
        return $("a[data-panel='review']").click()
      case "#digdeeper":
        return $("a[data-panel='dig']").click()
      case "#finally":
        return $("a[data-panel='final']").click()
      default:
        if ($(window).width() < 980) {
          return $("a[data-panel]:not([data-panel='watch'])").first().click()
        }
    }
  }

  changePanel(e) {
    const ie9 = $("html").hasClass("ie9")
    if (!ie9) {
      e.preventDefault()
    }
    const tab = $(e.target)

    this.updateUrl(tab, ie9)
    return this.updatePanels(tab)
  }

  updateUrl(tab, ie9) {
    if (
      tab.data("url") &&
      !ie9 &&
      `${tab.data("url")}` !==
        `${window.location.pathname}${window.location.hash}`
    ) {
      return history.pushState(null, null, `${tab.data("url")}`)
    }
  }

  onPanelSubtreeMod() {
    if (window.location.hash) {
      return this.activatePanel(window.location.hash)
    }
  }

  updatePanels(tab) {
    // Hide All Tabs On Panel Change (This allows Think panel to be open by default if > 980 view is active)
    $(".panels .panel").addClass("hide")

    const panelName = tab.data("panel")
    const panelDiv = $(".panel." + panelName)
    const panelWrap = panelDiv.parents(".panels")

    if (panelName === "watch") {
      $(".uiToggleSwitch").removeClass("closed")
      $(".videoContainer").removeClass("isRight")
      panelWrap.addClass("closed")
    } else {
      this.lessonsAll.logView()
      $(".uiToggleSwitch").addClass("closed")
      $(".videoContainer").addClass("isRight")
      panelWrap.removeClass("closed")
    }

    if (panelName === "review") {
      if (!panelDiv.hasClass("published")) {
        //rails-ujs requires native click event and not jQuery trigger event
        $(".openReviewBody").get(0).click()
      }
    }

    $(".panel.active").removeClass("active")
    $(".uiToggleSwitch .active").removeClass("active")

    tab.addClass("active")
    return panelDiv.addClass("active")
  }

  gotoQuestion() {
    if (window.location.hash.split("-")[0] === "#question") {
      const question = window.location.hash.split("-")[1]

      // highlight panel
      this.updatePanels($("#think-link"))

      // go to question
      $(".carouselContainer.review").triggerHandler("slideToPage", question - 1)

      // update url
      const url = $(".panel.review").data("url") + "#question-" + question
      return history.pushState(null, null, url)
    }
  }

  bindElements() {
    $(document).on("click.uiToggle", ".uiToggleSwitch a", e => {
      this.changePanel(e)
      return $("textarea").blur()
    })

    // Bind uiToggleSwitch Tooltips
    $(document).on("mouseenter.uiToggle", ".uiToggleSwitch li", function (e) {
      if (!$("body").hasClass("mobile_tablet")) {
        return $(this).find(".nav_tooltip").fadeIn(150).delay(1250).fadeOut(150)
      }
    })

    $(window).resize(() => {
      return this.activatePanel(window.location.hash)
    })

    const sideBar = document.getElementById("sideRail")
    const observer = new MutationObserver(this.onPanelSubtreeMod)
    return observer.observe(sideBar, {
      attributes: false,
      childList: true,
      subtree: true,
    })
  }
}
